import { render, staticRenderFns } from "./InputUserData.vue?vue&type=template&id=56bf2f12&scoped=true&"
import script from "./InputUserData.vue?vue&type=script&lang=js&"
export * from "./InputUserData.vue?vue&type=script&lang=js&"
import style0 from "./InputUserData.vue?vue&type=style&index=0&id=56bf2f12&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bf2f12",
  null
  
)

export default component.exports